import moment from "moment";

const isDev = location.hostname === "localhost" || location.hostname === "127.0.0.1";

const config = {
    backend_urls: {
        default: isDev ? "http://127.0.0.1:8001" : "https://tcmx.kaiboo.ltd",
        real_host: isDev ? "http://127.0.0.1:8001" : "http://172.16.1.185:5000",
    },
    frontend_url: isDev ? "http://127.0.0.1:8001" : "https://brain.kaiboo.ltd",
    backend_url: isDev ? "http://127.0.0.1:8001/tcmx/api" : "https://tcmx.kaiboo.ltd/tcmx/api",
    //望诊仪服务器URL
    wzy_url: "http://192.168.3.6:8000/",
    //wzy_url: "https://tcmx.kaiboo.ltd/tcmx/api",
    mock: false, // 是否使用mock数据
    debug: false,
    is_dev: isDev, // 是否为本地开发环境
    start_time: new moment(),
};
export default config;
